import { formatDecimal, operationSymbol } from "../lib/format";
import type { ConnectionState, WorldTerm } from "../lib/world";

interface CurrentReadoutProps {
  term: WorldTerm;
  connection: ConnectionState;
  catchingUp: boolean;
  isPaused: boolean;
  isExploring: boolean;
  behindBy: bigint;
}

const connectionCopy: Record<ConnectionState, string> = {
  connecting: "CONNECTING",
  live: "LIVE",
  reconnecting: "RESYNCING",
  offline: "OFFLINE MODEL",
};

export function CurrentReadout({ term, connection, catchingUp, isPaused, isExploring, behindBy }: CurrentReadoutProps) {
  const operation = operationSymbol(term.operation);
  const status = isPaused
    ? "DISPLAY PAUSED"
    : isExploring
      ? "EXPLORE"
      : catchingUp
        ? "CATCHING UP"
        : connectionCopy[connection];

  return (
    <section className="current-readout" id="current-term" aria-labelledby="current-term-title">
      <h2 id="current-term-title" className="sr-only">現在の項</h2>
      <div className={`live-state live-state--${connection}`} id="presentation-state">
        <span className="live-state__dot" aria-hidden="true" />
        <span>{status}</span>
      </div>
      {behindBy > 0n ? <p className="behind-copy">LIVEから {formatDecimal(behindBy.toString())} 項前</p> : null}
      <dl className="term-stats">
        <div className="term-stats__index">
          <dt>項番号</dt>
          <dd>n = {formatDecimal(term.n)}</dd>
        </div>
        <div className="term-stats__value">
          <dt>a(n)</dt>
          <dd>{formatDecimal(term.value)}</dd>
        </div>
        <div className={`term-stats__operation is-${term.operation}`}>
          <dt>採用した規則</dt>
          <dd>{operation}&nbsp; {formatDecimal(term.step)}</dd>
        </div>
      </dl>
    </section>
  );
}

